@if (identityService.isCompanySelectorVisible()) {
<mat-form-field
    appearance="outline"
    [ngClass]="isGlobalSelector ? 'selector-dropdown-button' : 'form-selector-dropdown-button'"
    (click)="SearchFilter = ''; selectorSearch.focus()"
>
    <mat-select
        id="organizationSelector"
        disableOptionCentering
        [panelClass]="isGlobalSelector ? 'selector-dropdown-wrap' : 'form-selector-dropdown-wrap'"
        [placeholder]="selectorPlaceholder"
        (openedChange)="onSelectorOpenedChange($event)"
        [(ngModel)]="SelectedOrganization"
        [disabled]="disableSelector"
        #organizationSelector
        tabindex="7"
        (keydown)="onKeyDown($event)"
    >
        <!-- Text displayed inside the selector when an option is selected -->
        @if (isGlobalSelector) {
        <mat-select-trigger class="fs-14 letter-spacing-0"><span i18n>Company</span>: {{ SelectedOrganization?.name }} </mat-select-trigger>
        }
        <!-- Search input field -->
        <mat-form-field
            class="selector-company-search"
            appearance="outline"
        >
            <label>
                <input
                    matInput
                    type="text"
                    autofocus
                    autocomplete="off"
                    i18n-placeholder
                    placeholder="Search"
                    #selectorSearch
                    (keydown)="onKeyDown($event)"
                    [(ngModel)]="SearchFilter"
                />
            </label>
            @if (SearchFilter) {
            <button
                matSuffix
                mat-icon-button
                (click)="SearchFilter = ''"
                class="inline-block"
            >
                <mat-icon>close</mat-icon>
            </button>
            } @if (!SearchFilter) {
            <button
                matSuffix
                mat-icon-button
                disabled
                class="inline-block"
            >
                <mat-icon>search</mat-icon>
            </button>
            }
        </mat-form-field>
        <!-- Company list -->
        @if (organizationsDataSource.Data) {
        <section class="selector-list-wrap">
            <cdk-virtual-scroll-viewport
                class="organizations-list"
                itemSize="32"
                [style.height.px]="32 * DisplayedCompanies"
                (scrolledIndexChange)="onScroll($event)"
            >
                @if (hasAppliedFilter && !organizationsDataSource.Data.length) {
                <p class="mat-typography full-width no-results-notice">
                    <em i18n>No results</em>
                </p>

                } @if (!hasAppliedFilter && showGlobalOption) {
                <mat-option [value]="null">
                    <span
                        class="fs-14 letter-spacing-0 organization-option"
                        i18n
                        >All managed companies</span
                    >
                </mat-option>
                } @if (!hasAppliedFilter && !isGlobalSelector) {
                <mat-option
                    [value]="null"
                    id="select-option"
                >
                    <span
                        style="font-style: italic"
                        i18n
                        >Select</span
                    >
                </mat-option>
                }
                <mat-option
                    class="organization-option"
                    *cdkVirtualFor="let org of organizationsDataSource"
                    [value]="org"
                >
                    {{ org ? org.name : LoadingMessage }}
                </mat-option>
            </cdk-virtual-scroll-viewport>
        </section>
        }
        <!-- "Fake" hidden entry in dropdown list for the selected company -->
        @if (SelectedOrganization !== null) {
        <mat-option
            style="display: none"
            [value]="SelectedOrganization"
        >
            {{ SelectedOrganization.name }}
        </mat-option>
        }
    </mat-select>
</mat-form-field>
}
